import "react";
import { twMerge as e } from "tailwind-merge";
import { Button as t } from "@systemeio/components";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/button/button.tsx
var r = ({ isFetching: r, className: i, ...a }) => /* @__PURE__ */ n(t, {
	variant: "primary",
	size: "md",
	isLoading: r,
	className: e("ai-chat-gradient-button text-text-on border-none", i),
	...a
});
//#endregion
export { r as GradientButton };
